import { BehaviorSubject, filter, map, Observable, repeatWhen, takeUntil } from 'rxjs';
import { ViewWillEnter, ViewWillLeave } from '@ionic/angular';
import { IIonicPageComponent } from './ionic-page-component.interface';

export abstract class IonicPageComponent implements ViewWillEnter, ViewWillLeave, IIonicPageComponent {
  private readonly viewWillEnter = new BehaviorSubject<boolean>(false);
  private readonly viewWillLeave = new BehaviorSubject<boolean>(false);

  readonly viewWillEnter$ = this.viewWillEnter.asObservable().pipe(
    filter((value) => value),
    map(() => void 0),
  );
  readonly viewWillLeave$ = this.viewWillLeave.asObservable().pipe(
    filter((value) => value),
    map(() => void 0),
  );

  ionViewWillEnter() {
    this.viewWillEnter.next(true);
    this.viewWillLeave.next(false);
  }

  ionViewWillLeave() {
    this.viewWillEnter.next(false);
    this.viewWillLeave.next(true);
  }

  protected untilPageActive<T>(): (source: Observable<T>) => Observable<T> {
    return (source: Observable<T>): Observable<T> => {
      return source.pipe(
        takeUntil<T>(this.viewWillLeave$),
        repeatWhen(() => this.viewWillEnter$),
      );
    };
  }
}
